import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaLock, FaUser } from 'react-icons/fa';
import { MdOutlinePointOfSale } from "react-icons/md";
import LocationsSidebar from './LocationsSidebar';
import { GrSchedule } from 'react-icons/gr';
import { CiShop } from 'react-icons/ci';
import tokenService from '../utils/tokenService';
import authService from '../services/authService';

const Sidebar = () => {
    const [userNumber, setUserNumber] = useState();
    const phoneNumber = tokenService.getUserPhoneNumber();

    const onLogout = async (e) => {
        await authService.logout();
        tokenService.clearTokens();
        window.location = '/';
    }

    useEffect(() => {
        setUserNumber(phoneNumber);
    }, []);

    const component = () => {
        return (
            <nav className="navbar navbar-expand-lg" style={{backgroundColor: "#e3f2fd"}}>
                <div className="container-fluid">
                    {/* Sidebar Header */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#sidebarMenu"
                        aria-controls="sidebarMenu"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
    
                    {/* Collapsible Sidebar */}
                    <div className="collapse navbar-collapse" id="sidebarMenu">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item" key='orders'>
                                <NavLink to="/" className={({ isActive }) => 
                                    isActive ? 'nav-link active' : 'nav-link'
                                }>
                                    <MdOutlinePointOfSale className="me-2" /> Брони
                                </NavLink>
                            </li>
                            <li className="nav-item" key='users'>
                                <NavLink to="/users" className={({ isActive }) => 
                                    isActive ? 'nav-link active' : 'nav-link'
                                }>
                                    <FaUser className="me-2" /> Пользователи
                                </NavLink>
                            </li>
                            <li className="nav-item" key='owners'>
                                <NavLink to="/owners" className={({ isActive }) => 
                                    isActive ? 'nav-link active' : 'nav-link'
                                }>
                                    <CiShop className="me-2" /> Владельцы
                                </NavLink>
                            </li>
                            <li className="nav-item" key='locks'>
                                <NavLink to="/locks" className={({ isActive }) => 
                                    isActive ? 'nav-link active' : 'nav-link'
                                }>
                                    <FaLock className="me-2" /> Замки
                                </NavLink>
                            </li>
                            <li className="nav-item" key='schedules'>
                                <NavLink to="/schedules" className={({ isActive }) => 
                                    isActive ? 'nav-link active' : 'nav-link'
                                }>
                                    <GrSchedule className="me-2" /> Сроки аренды
                                </NavLink>
                            </li>
                            <hr/>
                            <LocationsSidebar/>
                        </ul>
                    
                        <div className="d-flex">
                            <span className='navbar-text p-2'>{userNumber}</span>
                            <button className='btn btn-secondary' onClick={onLogout}>Выход</button>
                        </div>
                    </div>
                </div>
            </nav>
        );
    };

    return component();
};

export default Sidebar;
